import * as React from "react"

import Breadcrumb from "./Breadcrumb"
import { IBreadcrumbInfo } from "../../index"

interface Props {
    sortedBreadcrumbs: IBreadcrumbInfo[]
}

export const FullStructure = ({ sortedBreadcrumbs }: Props): JSX.Element => (
    <>
        {sortedBreadcrumbs.map((br) => (
            <Breadcrumb key={br.uuid} breadcrumbInfo={br} />
        ))}
    </>
)

export default FullStructure
